//引入Vue
import Vue from "vue";
//引入App
import App from './App';
// 引入Store
import store from './store'
//引入 vue-router
import VueRoutter from 'vue-router';
// 引入 router 对象
import router from './router'
// element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// 引入语言包
import VueI18n from 'vue-i18n'   // 1. 引入插件
import en from './lang/en'       // 2. 引入英文语言包
import zh from './lang/zh'       // 2. 引入中文语言包
Vue.use(VueI18n) // 3. 安装插件
// 4. 创建 i18n 实例
const savedLang = localStorage.getItem('lang') || 'zh';
const i18n = new VueI18n({
	// 设置当前默认语言为中文
	locale: savedLang,     	
	// 当找不到指定语言文案时，回退到中文，这能有效避免页面显示空白[citation:2]
	fallbackLocale: 'zh', 	
	// 注册语言包
	messages: {       		
		en,
		zh
	}
})

// 引入动画
import 'animate.css'
// import animate from 'animate.css'
// Vue.use(animate);

// 2. 引入 wowjs
import WOW from 'wowjs'

// 修复 wow.js 1.1.3 在 webpack 打包环境下的兼容性问题：
// 其 dist/wow.js 模块顶层的 getComputedStyle 兜底函数依赖 this === window，
// 打包后模块作用域内 this 不再指向 window，调用时会执行 this.getPropertyValue = ...
// 从而抛出 "Cannot set properties of undefined (setting 'getPropertyValue')"。
// 这里用标准 API 重写 animationName，直接绕过 vendorCSS 与损坏的兜底逻辑。
WOW.WOW.prototype.animationName = function (box) {
	var name = ''
	try {
		name = window.getComputedStyle(box).getPropertyValue('animation-name')
	} catch (e) {
		name = ''
	}
	return name === 'none' ? '' : name
}

// 全局唯一的 WOW 实例（路由切换后复用，避免重复绑定滚动监听）
let wowInstance = null

// 引入mixin主
import { mixin, shareData } from "@/js/mixin";
Vue.mixin(mixin);
// Vue.mixin(shareData);

//引入判断函数
import regular from '@/js/regular.js';
Vue.prototype.$regular = regular;

//全局过滤器
import filters from '@/js/filter.js';
Object.keys(filters).forEach(key=>{
    Vue.filter(key,filters[key])
})

// 全局事件总线
Vue.prototype.$bus = new Vue()

//关闭Vue的生产提示
Vue.config.productionTip = false;
Vue.use(VueRoutter)

// Vue
new Vue({
    el: '#app',
    render: h => h(App),
	i18n,
    store,
    router,
	mounted() {
		wowInstance = new WOW.WOW({
			boxClass:'wow',// default 在用户滚动时显示隐藏框的类名。
			animateClass:'animate__animated',// animate.css v4 的基础动画类名是 animate__animated（v3 才是 animated）
			offset:0,// default 定义浏览器视口底部与隐藏框顶部之间的距离。当用户滚动并达到此距离时，将显示隐藏框。
			mobile:true,// default 在移动设备上打开/关闭 wow.js。
			live:true,// default 持续检查页面上是否有新的 WOW 元素。
		})
		wowInstance.init()
	},
    beforeCreate(){
        Vue.prototype.$bus = this
    },
});

// 路由切换后，新页面组件渲染出的 .wow 元素需要重新扫描才能触发动画
// （wow.js 的 live 模式依赖 MutationObserver，打包后已降级失效，需手动 sync）
router.afterEach(() => {
	Vue.nextTick(() => {
		if (wowInstance) {
			wowInstance.sync()
		}
	})
})

